import { apiConnector } from "./ApiConnector";
import { musicEndPoint } from "./AllApi";

// Get all music
export const getAllMusic = async () => {
  try {
    const response = await apiConnector(
      "GET",
      musicEndPoint.GET_ALL_MUSIC_API,
      null,
      null,
      null
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching all music:", error);
    throw error;
  }
};

// Get music by ID
export const getMusicById = async (musicId) => {
  try {
    const response = await apiConnector(
      "GET",
      `${musicEndPoint.GET_MUSIC_BY_ID_API}/${musicId}`,
      null,
      null,
      null
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching music by ID:", error);
    throw error;
  }
};

// Filter music by type
export const getMusicByType = async (type) => {
  try {
    const allMusic = await getAllMusic();
    if (allMusic.status === "success") {
      const filteredMusic = allMusic.data.filter(music => 
        music.type.toLowerCase() === type.toLowerCase()
      );
      return {
        status: "success",
        data: filteredMusic,
        count: filteredMusic.length
      };
    }
    return allMusic;
  } catch (error) {
    console.error("Error filtering music by type:", error);
    throw error;
  }
};
